import {EventEmitter, Injectable, Output} from '@angular/core';
import {CrudService} from '../crud/crud.service';
import {Spring} from '../spring/spring';
import {Constants} from '../constants/constants';
import {EventosTablaInterface} from '../interfaces/eventos-tabla.interface';
import {PreferencesUserInterface} from '../interfaces/preferences-user.interface';
import {UtileriasService} from './utilerias.service';

@Injectable({
  providedIn: 'root'
})
export class UspreferService {

  preferenceUser: PreferencesUserInterface;

  constructor(private crud: CrudService,
              private spring: Spring,
              private constants: Constants,
              private utileriasService: UtileriasService) {
  }

  postUsprefer(usprefer: any) {
    return this.crud.post(`${this.spring.USPREFER}`, usprefer);
  }

  getPreferenciasUsuario(idusuari: number) {
    return this.crud.get(`${this.spring.GET_PREFERENCIAS_USUARIO}${idusuari}`);
  }

  eliminardatosoptimizacion(idusuari: number) {
    return this.crud.delete(`${this.spring.DELETE_PREFERENCIAS_USUARIO}${idusuari}`);
  }


  setSearchData(searchFilter: string, searchForm: any, evento: any, idusuari: number) {

    if (searchFilter == this.constants.TEMA_USUARIO) {
      sessionStorage.setItem(searchFilter, this.utileriasService.encrypt(JSON.stringify(searchForm)));
      this.updatePreferenceDataBase(searchForm, searchFilter, idusuari);
      return null;
    } else {
      evento = {
        accion: this.constants.BUSCAR,
        objeto: searchForm.value
      }
      sessionStorage.setItem(searchFilter, this.utileriasService.encrypt(JSON.stringify(searchForm.value)));
      this.updatePreferenceDataBase(searchForm.value, searchFilter, idusuari);
      return evento;
    }
  }

  loadSearchData(searchFilter: string, searchForm: any, evento: any) {
    let search;
    if (sessionStorage.getItem(searchFilter) != null) {
      search = JSON.parse(this.utileriasService.decrypt(sessionStorage.getItem(searchFilter)));
    }

    if (searchFilter == this.constants.TEMA_USUARIO) {
      if (search !== null && search !== undefined) {
        return search;
      } else {
        return null;
      }
    } else {

      if (search !== null && search !== undefined) {
        for (const field in searchForm.controls) {
          if (search[field] !== undefined) {
            searchForm.get(field).setValue(search[field]);
          }
        }
        evento = {
          accion: this.constants.BUSCAR,
          objeto: search
        }
      } else {
        evento = {
          accion: this.constants.BUSCAR,
          objeto: searchForm.value
        }
        sessionStorage.setItem(searchFilter, this.utileriasService.encrypt(JSON.stringify(searchForm.value)));
      }
      return evento;

    }


  }

  updatePreferenceDataBase(preferenceStorage: any, searchFilter: string, idusuari: number): void {
    this.preferenceUser = {
      idusuari: idusuari,
      tabla: searchFilter,
      preferencias: JSON.stringify(preferenceStorage)
    }
    this.postUsprefer(this.preferenceUser).subscribe();
  }

  getEventPostData(searchFilter: string, evento: any) {
    let search;
    if (sessionStorage.getItem(searchFilter) != null) {
      search = JSON.parse(this.utileriasService.decrypt(sessionStorage.getItem(searchFilter)));
    }
    evento = {
      accion: this.constants.BUSCAR,
      objeto: search
    }
    return evento;
  }

}
